export default __webpack_public_path__ + "static/media/HarmonyLauncher_icon.5b35795c.jpg";